import { Component, Inject, Input, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';


export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  textExtra:string
}

@Component({
  selector: 'app-model-modal-txt',
  templateUrl: './model-modal-txt.component.html',
  styleUrls: ['./model-modal-txt.component.scss']
})
export class ModelModalTxtComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModelModalTxtComponent>,  @Inject(MAT_DIALOG_DATA) public data: DialogData,) { }

  ngOnInit(): void {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}